module.exports = __webpack_public_path__ + "img/knights-logo.8a5135cc.png";